import getMandatoryEnv from "sites-common/utils/getMandatoryEnv";

const logOut = async () => {
  if (typeof window !== "undefined") {
    const { userLogout } = await import("hfnauth/main");
    const { keycloakConfig } = getMandatoryEnv(["keycloakConfig"]);
    const res = await userLogout(keycloakConfig);
    if (!res?.error) {
      return true;
    }
    if (res?.error && res?.message) {
      return false;
    }
  }
  return false;
};
export default logOut;
